import { render, staticRenderFns } from "./AIAssessment.vue?vue&type=template&id=4904fa0b&scoped=true"
import script from "./AIAssessment.vue?vue&type=script&lang=js"
export * from "./AIAssessment.vue?vue&type=script&lang=js"
import style0 from "./AIAssessment.vue?vue&type=style&index=0&id=4904fa0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904fa0b",
  null
  
)

export default component.exports